const scrollTop = (scrollTopButtonSelector) => {
  const scrollTopButton = document.querySelector(scrollTopButtonSelector);
  if (!scrollTopButton) return false;

  scrollTopButton.addEventListener("click", (e) => {
    e.preventDefault();

    window.scrollTo({ top: 0, behavior: "smooth" });
  });
};

scrollTop(".voyager-footer__scroll-top");
